module.exports = __webpack_public_path__ + "media/images/forms-icons/feedback-icon-hover-473ae7e03cb9edd80b474f564da0d139.svg";